import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import i18n from 'i18next'
import ruRU from 'antd/es/locale/ru_RU'
import { ConfigProvider, theme } from 'antd'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { rootStore } from './redux/root/root.store'
import moment from 'moment'

import 'moment/locale/ru'
import 'moment/locale/ky'

moment.locale('ru')

//Localisaton
i18n
	.use(initReactI18next) // passes i18n down to react-i18next
	.use(LanguageDetector)
	.use(HttpApi)
	.init({
		supportedLngs: ['ky', 'ru'],
		fallbackLng: 'ru',
		detection: {
			order: ['cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
			caches: ['cookie'],
		},
		backend: {
			loadPath: '/assets/locales/{{lng}}/translation.json',
		},
	})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)


root.render(
	<React.Suspense>
		<ConfigProvider
			locale={ruRU}
			theme={{
				algorithm:
					localStorage.getItem('theme') === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
			}}
		>
			<Provider store={rootStore}>
				<App />
			</Provider>
		</ConfigProvider>
	</React.Suspense>
)
